module.exports = "## Circular Progress\n[Circular Progress](https://www.google.com/design/spec/components/progress-activity.html#progress-activity-types-of-indicators)\nwill rotate to show the progress of a task or that there is a wait for a task to complete. \n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/CircularProgress/README.md
 ** module id = 955
 ** module chunks = 0
 **/